export default {
    ru: {
        user_title: 'Данные пользователя',
        user_description: 'Укажите ваши данные для безопасности',
        name: 'Имя',
        fullname_link_title: 'Задать имя',
        login: 'Логин',
        email: 'Электронная почта',
        email_description: 'Для получения уведомлений',
        email_link_title: 'Привязать электронную почту',
        password: 'Пароль',
        password_link_title: 'Задайте пароль',
        password_description: 'Для входа по email',
        passpromptLabel: 'Введите пароль',
        passweakLabel: 'Слишком простой',
        passmediumLabel: 'Уже лучше',
        passstrongLabel: 'Идеально!',
        password_confirm: 'Подтверждение пароля',
        phone: 'Телефон',
        phone_description: 'Для оперативной связи',
        phone_link_title: 'Привязать телефон',
        country: 'Страна',
        choose_country: 'Выберите страну',
        button_edit: 'Редактировать',
        button_save: 'Сохранить',
        button_cancel: 'Отмена',
        button_set: 'Задать',
        button_change: 'Изменить',
        mess_success: 'Успех',
        mess_success_text: 'Данные успешно сохранены',
    },
    en: {
        user_title: 'User Data',
        user_description: 'Provide your data for security',
        name: 'Name',
        fullname_link_title: 'Set fullname',
        login: 'Login',
        email: 'Email',
        email_description: 'For receiving notifications',
        email_link_title: 'Link email',
        password: 'Password',
        password_link_title: 'Set password',
        password_description: 'For logging in with email',
        passpromptLabel: 'Enter a password',
        passweakLabel: 'Weak',
        passmediumLabel: 'Medium',
        passstrongLabel: 'Strong',
        password_confirm: 'Password confirmation',
        phone: 'Phone',
        phone_description: 'For urgent communication',
        phone_link_title: 'Link phone',
        country: 'Country',
        choose_country: 'Choose country',
        button_edit: 'Edit',
        button_save: 'Save',
        button_cancel: 'Cancel',
        button_set: 'Set',
        button_change: 'Change',
        mess_success: 'Success',
        mess_success_text: 'Data saved successfully',
    }
}